import EntityEditor, {EntityProps} from "./entityEditor";
import {AddUnitCommand} from "../../commands/addUnit.command";
import {UpdateUnitCommand} from "../../commands/updateUnit.command";
import {RemoveUnitCommand} from "../../commands/removeUnit.command";
import {useIntegrator} from "../../integrator.context";
import {AddConstantUnitAttribute} from "../../commands/addConstantUnitAttribute.command";
import {RemoveUnitAttributeCommand} from "../../commands/removeUnitAttribute.command";
import {AddUnitAttributeCommand} from "../../commands/addUnitAttribute.command";
import {RemoveConstantUnitAttribute} from "../../commands/removeConstantUnitAttribute.command";
import {useApp} from "../../app.context";

function UnitsEditorView() {
    const {state, executeCommand} = useIntegrator();
    const {focusedUnit, navigateToUnit} = useApp();

    return (
        <EntityEditor name={'Unit'} entities={state.units.map((unit): EntityProps => {
            return {
                id: unit.id,
                unit: unit,
                statistics: [
                    {
                        value: unit.price,
                        field: 'unit.price',
                        onChange(value: number) {
                            unit.price = value;
                            executeCommand(new UpdateUnitCommand(unit));
                        }
                    },
                    {
                        value: unit.score,
                        field: 'unit.score',
                        onChange(value: number) {
                            unit.score = value;
                            executeCommand(new UpdateUnitCommand(unit));
                        }
                    },
                    {
                        value: unit.properties.attack,
                        field: 'unit.properties.attack',
                        onChange(value: number) {
                            unit.properties.attack = value;
                            executeCommand(new UpdateUnitCommand(unit));
                        }
                    },
                    {
                        value: unit.properties.defense,
                        field: 'unit.properties.defense',
                        onChange(value: number) {
                            unit.properties.defense = value;
                            executeCommand(new UpdateUnitCommand(unit));
                        }
                    },
                    {
                        value: unit.properties.health,
                        field: 'unit.properties.health',
                        onChange(value: number) {
                            unit.properties.health = value;
                            executeCommand(new UpdateUnitCommand(unit));
                        }
                    },
                    {
                        value: unit.properties.movementSpeed,
                        field: 'unit.properties.movementSpeed',
                        onChange(value: number) {
                            unit.properties.movementSpeed = value;
                            executeCommand(new UpdateUnitCommand(unit));
                        }
                    },
                    {
                        value: unit.properties.range,
                        field: 'unit.properties.range',
                        onChange(value: number) {
                            unit.properties.range = value;
                            executeCommand(new UpdateUnitCommand(unit));
                        }
                    },
                    {
                        value: unit.properties.regeneration,
                        field: 'unit.properties.regeneration',
                        onChange(value: number) {
                            unit.properties.regeneration = value;
                            executeCommand(new UpdateUnitCommand(unit));
                        }
                    }
                ],
                attributes: unit.attributes
            }
        })}
                      metadata={state.unitAttributes}
                      focusedEntity={focusedUnit}
                      addNewEntity={(name) => { const c = new AddUnitCommand(name); executeCommand(c); if (c.newId) navigateToUnit(c.newId); }}
                      addNewAttribute={(attribute) => executeCommand(new AddConstantUnitAttribute(attribute))}
                      deleteEntity={(id) => executeCommand(new RemoveUnitCommand(id))}
                      deleteEntityAttribute={(id, attribute) => executeCommand(new RemoveUnitAttributeCommand(id, attribute))}
                      addEntityAttribute={(id, attribute) => executeCommand(new AddUnitAttributeCommand(id, attribute))}
                      deleteAttribute={(attribute) => executeCommand(new RemoveConstantUnitAttribute(attribute))}/>
    )
}

export default UnitsEditorView;